import { useQueryClient, useMutation } from 'react-query';

// Our Axios
import axiosInstance from 'services/API/API';

// Our Query Keys
import { ERROR_MESSAGE_DATA } from 'shared/query-keys';

// Our Endpoint
import { analyticsOfferUrl } from 'shared/api-urls';

const useMutateGetAnalyticsSavings = () => {
	const queryClient = useQueryClient();

	return useMutation(
		async (offerRequestDetails) => {
			const response = await axiosInstance.post(
				`${analyticsOfferUrl}/interest-savings`,
				offerRequestDetails
			);

			const analyticsInterestSavingsData = response.data.data;

			return analyticsInterestSavingsData;
		},

		{
			onError: (error) => {
				queryClient.setQueryData(ERROR_MESSAGE_DATA, error.message);
			}
		}
	);
};

export default useMutateGetAnalyticsSavings;
